// Truthful evidence-state + status vocabularies → visual styling.
// NEVER invents HEALTHY/ACTIVE; missing evidence renders as its real state.

// Metric evidence states (from CC core.py EVIDENCE vocab).
export const EVIDENCE_META = {
  VERIFIED: { label: "Verified", dot: "#22c55e", text: "text-emerald-300", chip: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30" },
  ESTIMATED: { label: "Estimated", dot: "#3b82f6", text: "text-blue-300", chip: "bg-blue-500/10 text-blue-300 border-blue-500/30" },
  STALE: { label: "Stale", dot: "#eab308", text: "text-yellow-300", chip: "bg-yellow-500/10 text-yellow-300 border-yellow-500/30" },
  UNKNOWN: { label: "Unknown", dot: "#71717a", text: "text-zinc-400", chip: "bg-zinc-500/10 text-zinc-300 border-zinc-500/30" },
  NOT_CONNECTED: { label: "Not Connected", dot: "#a1a1aa", text: "text-zinc-400", chip: "bg-zinc-500/10 text-zinc-300 border-zinc-500/30" },
  NOT_CONFIGURED: { label: "Not Configured", dot: "#a1a1aa", text: "text-zinc-400", chip: "bg-zinc-500/10 text-zinc-300 border-zinc-500/30" },
  NOT_VERIFIED: { label: "Not Verified", dot: "#eab308", text: "text-yellow-300", chip: "bg-yellow-500/10 text-yellow-300 border-yellow-500/30" },
  ERROR: { label: "Error", dot: "#ef4444", text: "text-red-300", chip: "bg-red-500/10 text-red-300 border-red-500/30" },
};

// Connector / system health states.
export const HEALTH_META = {
  HEALTHY: { label: "Healthy", chip: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30", dot: "#22c55e" },
  WARNING: { label: "Warning", chip: "bg-yellow-500/10 text-yellow-300 border-yellow-500/30", dot: "#eab308" },
  DEGRADED: { label: "Degraded", chip: "bg-yellow-500/10 text-yellow-300 border-yellow-500/30", dot: "#eab308" },
  CRITICAL: { label: "Critical", chip: "bg-red-500/10 text-red-300 border-red-500/30", dot: "#ef4444" },
  FAILED: { label: "Failed", chip: "bg-red-500/10 text-red-300 border-red-500/30", dot: "#ef4444" },
  MAINTENANCE: { label: "Maintenance", chip: "bg-blue-500/10 text-blue-300 border-blue-500/30", dot: "#3b82f6" },
  DISCONNECTED: { label: "Disconnected", chip: "bg-zinc-500/10 text-zinc-300 border-zinc-500/30", dot: "#a1a1aa" },
  AUTH_REQUIRED: { label: "Auth Required", chip: "bg-orange-500/10 text-orange-300 border-orange-500/30", dot: "#f97316" },
  RATE_LIMITED: { label: "Rate Limited", chip: "bg-orange-500/10 text-orange-300 border-orange-500/30", dot: "#f97316" },
  UNKNOWN: { label: "Unknown", chip: "bg-zinc-500/10 text-zinc-300 border-zinc-500/30", dot: "#71717a" },
};

// Module/capability registration states (nav-item level).
export const MODULE_STATUS_META = {
  ACTIVE: { label: "Active", chip: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30" },
  FEATURE_DISABLED: { label: "Feature Disabled", chip: "bg-zinc-500/10 text-zinc-300 border-zinc-500/30" },
  NOT_IMPLEMENTED: { label: "Not Implemented", chip: "bg-zinc-500/10 text-zinc-400 border-zinc-600/30" },
  NOT_CONNECTED: { label: "Not Connected", chip: "bg-zinc-500/10 text-zinc-300 border-zinc-500/30" },
  ACCESS_RESTRICTED: { label: "Access Restricted", chip: "bg-red-500/10 text-red-300 border-red-500/30" },
};

const REAL_NUMBER = new Set(["VERIFIED", "ESTIMATED", "STALE"]);

// Format a CC metric ({value, unit, state}) for display — never fabricates a number
// for a non-reported state.
export function formatMetric(m) {
  if (!m) return { display: "—", isValue: false, state: "UNKNOWN" };
  const meta = EVIDENCE_META[m.state] || EVIDENCE_META.UNKNOWN;
  if (m.value == null || !REAL_NUMBER.has(m.state)) {
    return { display: meta.label, isValue: false, state: m.state };
  }
  let display;
  const v = m.value;
  if (m.unit === "USD") display = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(v);
  else if (m.unit === "PERCENT") display = `${v}%`;
  else if (m.unit === "SECONDS") display = `${v}s`;
  else display = new Intl.NumberFormat("en-US").format(v);
  return { display, isValue: true, state: m.state };
}
